import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/react-query';

export const deleteTeamMember = ({
  teamId,
  memberId,
}: {
  teamId: string;
  memberId: string;
}) => {
  return api.delete(`/teams/${teamId}/members/${memberId}`, {
    withCredentials: true,
  });
};

type UseDeleteTeamMemberOptions = {
  teamId: string;
  mutationConfig?: MutationConfig<typeof deleteTeamMember>;
};

export const useDeleteTeamMember = ({
  teamId,
  mutationConfig,
}: UseDeleteTeamMemberOptions) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['teams', teamId, 'members'],
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: deleteTeamMember,
  });
};
